module.exports = __webpack_public_path__ + "img/172.2d58b616.jpg";